// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import cn from 'classnames';
import {Trans as T, useTranslation} from 'react-i18next';
import {Settings_context} from '../settings_ctx';
import './payment_progress.module.less';
import {qs_parse} from 'zurl';
import {useLocation} from 'react-router-dom';
import Icon_navig_left from '../img/svg/navig/left.svg';
import {Svg} from '../ui/svg';

interface i_payment_progress_props {
    slide: string;
    on_click_select: (ev?:React.MouseEvent)=>void;
    on_click_payment: (ev?:React.MouseEvent)=>void;
}

export const Payment_progress = (props:i_payment_progress_props)=>{
    useTranslation();
    const {theme} = useContext(Settings_context);
    const {slide, on_click_select, on_click_payment} = props;
    const {search} = useLocation();
    const qs_o = qs_parse(search.substr(1), {safe: true});
    return <ul className="payment-progress">
      {qs_o.back && <Fragment>
        <li className={'back_btn_pp'}>
          <a onClick={()=>{
            location.href = qs_o.back=='VPN' ?
            `/vpn_config?appid=${qs_o.appid}&uuid=${qs_o.uuid}`+
            `&app_ver=${qs_o.app_ver}` : '#';
          }} className={cn(theme.P, theme.xs)}>
            <Svg icon={<Icon_navig_left width={16} height={10}/>}/> <T>Back</T>
          </a>
        </li>
        <div className="spacer"/>
      </Fragment>}
      <li className={cn(slide=='select_plan' ? 'active' : 'completed')}>
        <a onClick={on_click_select} className={cn(theme.P, theme.xs)}>
          <T>Plan Selection</T>
        </a>
      </li>
      <div className="spacer"/>
      <li className={cn(slide=='payment' && 'active')}>
        <a onClick={on_click_payment} className={cn(theme.P, theme.xs)}>
          <T>Payment Completion</T>
        </a>
      </li>
    </ul>;
};
